import { h } from 'preact'
import classNames from 'clsx'

import { getDisplayName } from '../../utils'
import { formatDate } from '../../../date/format'
import LinkWrapper from '../link-wrapper'

import styles from './index.module.scss'

export function AsMeta(Component, displayName) {
  const WrappedComponent = props => {
    const {
      className,
      small,
      borderTop,
      borderBottom,
      marginBottom,
      ...rest
    } = props

    return (
      <Component
        {...rest}
        className={buildMetaClassNames({
          className,
          small,
          borderBottom,
          borderTop,
          marginBottom,
        })}
      />
    )
  }

  WrappedComponent.displayName = displayName || `AsMeta(${getDisplayName(Component)})`

  return WrappedComponent
}

export const Meta = AsMeta('div', 'Meta')

function buildMetaClassNames({ className, small, borderTop, borderBottom, marginBottom }) {
  return classNames(
    className,
    styles['a-meta'],
    {
      [styles['a-meta--small']]: small,
      [styles['a-meta--border-top']]: borderTop,
      [styles['a-meta--border-bottom']]: borderBottom,
      [styles['a-meta--margin-bottom']]: marginBottom,
    },
  )
}

export function MetaLink({ children, italic, className, ...rest }) {
  return (
    <LinkWrapper
      {...rest}
      className={classNames(
        className,
        { [styles['a-meta--italic']]: italic },
      )}
    >
      {children}
    </LinkWrapper>
  )
}

export function MetaDate({ className, italic, date = {}, ...rest }) {
  return (
    <abbr
      {...rest}
      title={date.iso}
      className={classNames(
        className,
        { [styles['a-meta--italic']]: italic },
      )}
    >
      {formatDate(date)}
    </abbr>
  )
}
